import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

export default function useGroups() {
  const refListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: false, thAttr: { width: '30' } },
    {
      key: 'name',
      sortable: false,
      label: 'Nhóm người dùng',
    },
    {
      key: 'description',
      sortable: false,
      label: 'Mô tả',
      thAttr: { width: '200' },
    },
    {
      key: 'actions',
      sortable: false,
      label: 'Hành động',
      thAttr: {},
      thClass: 'text-right',
      tdClass: 'text-right',
    },
  ];
  const loading = ref(false);
  const perPage = ref(30);
  const totalEntries = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 30, 50, 100];
  const searchQuery = ref('');
  const searchUserQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const settingFilter = ref(null);
  const planFilter = ref(null);
  const statusFilter = ref(null);
  const isPaginate = ref(1);
  const itemsData = ref([]);
  const groupData = ref(null);

  const reloadUserGroupList = computed(
    () => store.state.groups.reloadUserGroupList
  );

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value
      ? refListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    };
  });

  const assignUserToGroup = (id, data, callback) => {
    loading.value = true;
    store
      .dispatch('groups/assignUserToGroup', {
        id,
        data,
      })
      .then((response) => {
        loading.value = false;
        if (response.status === 200) {
          store.dispatch('groups/SET_RELOAD_USER_LIST', true);
          if (callback !== undefined) {
            callback(response.data.data);
          }
        }
      });
  };

  const fetchGroups = (cb) => {
    loading.value = true;
    store
      .dispatch('groups/fetchGroups', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        isPaginate: isPaginate.value,
      })
      .then((response) => {
        loading.value = false;
        if (response.status === 200) {
          const items = response.data.data.data;
          const { total } = response.data.data;
          totalEntries.value = total;
          itemsData.value = items;
          if (typeof cb === 'function') {
            cb(items);
          }
        }
      });
  };

  const refetchData = () => {
    fetchGroups();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const statusOptions = [
    { label: 'Đợi duyệt', id: 2 },
    { label: 'Đã kích hoạt', id: 1 },
    { label: 'Chưa kích hoạt', id: 0 },
  ];
  const resolveUserStatusVariant = (status) => {
    if (status === 2) return 'warning';
    if (status === 1) return 'success';
    if (status === 0) return 'secondary';
    return 'primary';
  };
  const resolveUserStatusText = (status) =>
    statusOptions.find((x) => x.id === status).label;

  return {
    loading,
    groupData,
    tableColumns,
    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    searchQuery,
    searchUserQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    itemsData,
    assignUserToGroup,
    fetchGroups,
    resolveUserStatusVariant,
    resolveUserStatusText,
    refetchData,

    // Extra Filters
    settingFilter,
    planFilter,
    statusFilter,
    statusOptions,
    reloadUserGroupList,
  };
}
